var map = {
	"./black.scss": "./library/styles/background/black.scss",
	"./image.scss": "./library/styles/background/image.scss",
	"./ocean.scss": "./library/styles/background/ocean.scss",
	"./white.scss": "./library/styles/background/white.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./library/styles/background sync \\.scss$";